import React, { useState,useEffect,useRef } from "react";
import { Container, Row, Col, Card, Button, Modal, Nav, Navbar } from "react-bootstrap";
import "./App.css"; // make sure to import the css file
import projects from "./positions.json";
import ThreeCube from './ThreeCube';
import InteractiveCard from './InteractiveCard';
import ResumeTable from './ResumeTable';
import ProjectTable from './ProjectTable';
import Landing from './Landing';
import HireMe from './HireMe';
import { v4 as uuidv4 } from 'uuid';
import { Banner } from './Banner'; 
import  ArtLab  from './ArtLab'; 
import HeaderVideoBinder from './HeaderVideoBinder';
// 1) Update import
import { BrowserRouter as Router, Route, Routes, Link, useLocation } from "react-router-dom";
import BioSection from './BioSection';
import ContactBinder from './ContactBinder';
import { Stack } from "react-bootstrap";
import ContactSectionBinder from "./ContactSectionBinder";
function Contact ({projects}){
  return (
    <>
    <ContactSectionBinder/>
    </>
    // <Container>
    //    <h1 className="display-4 mt-4">AI WORKFLOW ANALYSIS</h1>
    // <Row>
    //   {projects.map((project, idx) => (
    //     <Col key={idx} xs={12} md={4}>
    //         <InteractiveCard project={project} ></InteractiveCard>
    //     </Col>
    // ))}
    // </Row>
    // </Container>
  )
}

// 2) Add this tiny component (anywhere above App)
function SectionHeader() {
  const { pathname } = useLocation();
  const titles = {
    "/": "Home",
    "/contact": "Contact",
    "/experience": "Experience",
    "/about": "About",
    "/artlab": "ArtLab",
    "/designer_01_marketing_01": "Designer — Marketing 01",
    "/designer_01_revision_01": "Designer — Revision 01",
    "/designer_01_formatting_01": "Designer — Formatting 01",
    "/projects": "Projects",
    "/hireme": "Hire Me",
  };
  const title = titles[pathname];
  return title ? <h1 style={{ marginTop: 50, marginBottom: 30 }}>{title}</h1> : null;
}
// add above App()
function MainNavbar() {
  return (
    <Navbar className="desktop_navbar mb-3">
      <Navbar.Brand href="/">JUSTIN GIRARD</Navbar.Brand><br/>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mr-auto">
          <Nav.Link as={Link} to="/projects">Projects</Nav.Link>
          <Nav.Link as={Link} to="/contact">Contact</Nav.Link>
          <Nav.Link as={Link} to="/about">About</Nav.Link>
          <Nav.Link as={Link} to="/experience">Experience</Nav.Link>
        </Nav>
      </Navbar.Collapse>
      <Navbar.Collapse id="basic-navbar-nav2" className="justify-content-end">
      </Navbar.Collapse>
    </Navbar>
  );
}


// add above App()
function FlexNavbar() {
  return (
    <>
      <h1>JUSTIN GIRARD</h1>
    <Stack direction="horizontal" gap={2} className="mt-0">
      <Button as={Link} to="/projects" variant="link" className="text-black text-decoration-none px-1">
        Projects
      </Button>
      <Button as={Link} to="/contact" variant="link" className="text-black text-decoration-none px-1">
        Contact
      </Button>
      <Button as={Link} to="/about" variant="link" className="text-black text-decoration-none px-1">
        About
      </Button>
      <Button as={Link} to="/experience" variant="link" className="text-black text-decoration-none px-1">
        Experience
      </Button>
    </Stack>

    </>
  );
}


function App() {
  const [modalInfo, setModalInfo] = useState(null);


    // ****1) Add this near other hooks in App()
    const headerRef = useRef(null);

    // ****1) Add this near other hooks in App()
    useEffect(() => {
      const v = headerRef.current?.querySelector('video');
      if (!v) return;

      v.muted = true;                       // required for autoplay on most browsers
      v.setAttribute('playsinline', '');    // iOS/Safari inline autoplay
      const tryPlay = () => v.play().catch(() => {});

      // after it can play, try autoplay
      if (v.readyState >= 2) { tryPlay(); }
      v.addEventListener('canplay', tryPlay, { once: true });

      // fallback: trigger on first user interaction
      const unlock = () => tryPlay();
      window.addEventListener('pointerdown', unlock, { once: true });
      window.addEventListener('keydown', unlock, { once: true });

      return () => {
        v.removeEventListener('canplay', tryPlay);
        window.removeEventListener('pointerdown', unlock);
        window.removeEventListener('keydown', unlock);
      };
    }, []);



  useEffect(() => {
    if (!window.BrevoConversations) {
      window.BrevoConversationsID = '686fc31a33c8a687c10564e0';
      window.BrevoConversations = function () {
        (window.BrevoConversations.q = window.BrevoConversations.q || []).push(arguments);
      };
      const s = document.createElement('script');
      s.src = 'https://conversations-widget.brevo.com/brevo-conversations.js';
      s.async = true;
      document.head.appendChild(s);
    }
  }, []);

  const handleShow = (info) => {
    setModalInfo(info);
  };

  const handleClose = () => {
    setModalInfo(null);
  };

    return (
    <Router>

      <Container  style={{ position: 'relative' }}>
      <Row>
      <Col xs={0} md={4} className="px-5 "  >
      </Col>
      <Col xs={12} md={3} className="nav-col-under"  ></Col>
      <Col xs={12} md={3} className="px-0 my-0 nav-col"  >
        <h1 className="text-nowrap my-0 py-2 mobile_header" >JUSTIN GIRARD</h1>
        <MainNavbar />
        <div ref={headerRef}>   
            {/* <HeaderVideoBinder  style={{width:380}} className=" mt-4 mr-5" content_url="/sections/justin_videos_001.json" /> */}
            <HeaderVideoBinder  className=" mr-5 video-container" content_url="/sections/justin_videos_001.json" displayStyle='rectangle' />
        </div>
        <div className="desktop_navbar_block">
          <ContactBinder   className="mx-0 px-0 mt-3"  content_url="/sections/socials_bar.json" ></ContactBinder>
          <BioSection  className="mx-0 px-0 mt-3" />
        </div>
      </Col>
      <Col xs={0} md={4} className="px-5 mobile_block"  >
        <ContactBinder   className="mx-0 px-0 mt-3"  content_url="/sections/socials_bar.json" ></ContactBinder>
      </Col>
<Col xs={12} md={8}  className="px-0 main-content-container">

{/* <SectionHeader /> */}
        <Routes>
          <Route path="/contact" element={<><Contact projects={projects}></Contact></> } /> /{/* Display Contact component */}
          <Route path="/experience" element={<><ResumeTable /></>} /> {/* Display ResumeTable component */}
          <Route path="/about" element={<><Landing /></>} /> {/* Display ResumeTable component */}
          <Route path="/artlab" element={<><ArtLab content_url={"/landers/artlab.json"} /></>} /> {/* Display ResumeTable component */}
          <Route path="/designer_01_marketing_01" element={<><ArtLab content_url={"/landers/designer_01_marketing_01.json"} /></>} /> {/* Display ResumeTable component */}
          <Route path="/designer_01_revision_01" element={<><ArtLab content_url={"/landers/designer_01_revision_01.json"} /></>} /> {/* Display ResumeTable component */}
          <Route path="/designer_01_formatting_01" element={<><ArtLab content_url={"/landers/designer_01_formatting_01.json"} /></>} /> {/* Display ResumeTable component */}

          <Route path="/projects" element={<><ProjectTable /></>} /> {/* Display ResumeTable component */}
          <Route path="/" element={<><ArtLab content_url={"/landers/artlab.json"}  /></>} /> {/* Redirect to Contact by default */}
          <Route path="/home" element={<><ArtLab content_url={"/landers/artlab.json"}  /></>} /> {/* Redirect to Contact by default */}
          <Route path="/hireme" element={<><HireMe /></>} /> {/* Redirect to Contact by default */}
        </Routes>
        </Col>
    </Row>
       </Container>
      
    </Router>
  );
}

export default App;
